import { Table, TableContainer, Tbody, Th, Thead } from '@aloft/toolkit-sui';

import { selectOpinionOfSiteValuePrice } from '../../redux/features/selectors/opinionOfSiteValueSelectors.ts';
import { selectCostNew } from '../../redux/features/selectors/selectCostNew.ts';
import { selectDepreciatedCostOfImprovements } from '../../redux/features/selectors/selectDepreciatedCostOfImprovements.ts';
import { selectSubjectValue } from '../../redux/features/selectors/selectSubjectValue.ts';
import { RootState } from '../../redux/types.ts';
import { Typography } from '../../summary/components/Typography.tsx';
import { CostApproachTableRollupRow } from './CostApproachTableRollupRow.tsx';
import { AdditionalStructuresCostRow } from './rows/AdditionalStructuresCostRow.tsx';
import { AsIsRow } from './rows/AsIsRow.tsx';
import { BasementCostRow } from './rows/BasementCostRow.tsx';
import { DepreciationContentRow } from './rows/DepreciationContentRow.tsx';
import { DepreciationHeaderRow } from './rows/DepreciationHeaderRow.tsx';
import { DwellingCostRow } from './rows/DwellingCostRow.tsx';
import { GarageCarportCostRow } from './rows/GarageCarportCostRow.tsx';

export const CostApproachTable = () => {
  return (
    <TableContainer className="cost-approach-table">
      <Table>
        <Thead>
          <Th>
            <Typography variant="h4">Feature</Typography>
          </Th>
          <Th>
            <Typography variant="h4">Cost Data</Typography>
          </Th>
        </Thead>
        <Tbody>
          <CostApproachTableRollupRow
            label="Opinion of Site Value"
            selector={selectOpinionOfSiteValuePrice}
          />
          <DwellingCostRow />
          <BasementCostRow />
          <AdditionalStructuresCostRow />
          <GarageCarportCostRow />
          <CostApproachTableRollupRow
            label="Total Estimate Cost-New"
            selector={(state: RootState) => selectCostNew(state, 'subject')}
          />
          <DepreciationHeaderRow />
          <DepreciationContentRow />
          <CostApproachTableRollupRow
            label="Depreciated Cost of Improvements"
            selector={(state: RootState) => selectDepreciatedCostOfImprovements(state, 'subject')}
          />
          <AsIsRow />
          <CostApproachTableRollupRow
            label="Indicated Value by Cost Approach"
            selector={selectSubjectValue}
          />
        </Tbody>
      </Table>
    </TableContainer>
  );
};
